module.exports = __webpack_public_path__ + "static/media/finance.bb06db69.png";